import { InputConfig } from "../types";
import classNames from "classnames";
import React from "react";
import Variant from "../../../enums/Variant";
import Size from "../../../enums/Size";
import { InputType } from "../../enum";

function Input({ type = InputType.TEXT, ...props }: InputConfig) {
  const computedClassNames = React.useMemo(
    () => getClassNames(props.className, props.variant, props.size, props.hasError, props.switchIconPosition),
    [props.className, props.variant, props.size, props.hasError, props.switchIconPosition]
  );

  return (
    <div className={computedClassNames}>
      {!props.switchIconPosition && props.icon ? (
        <span className="input_icon" data-testid={`${props.name}_iconPosition--left`}>
          {props.icon}
        </span>
      ) : null}
      <input
        id={props.name}
        type={type}
        name={props.name}
        value={props.value}
        ref={props.innerRef}
        onBlur={props.onBlur}
        data-testid={props.name}
        onChange={props.onChange}
        disabled={props.disabled}
        autoFocus={props.autoFocus}
        placeholder={props.placeholder}
        autoComplete={props.autoComplete}
        onFocus={props.onFocus}
        onKeyDown={props.onKeyDown}
        {...(props.disablePaste ? { onPaste: e => e.preventDefault() } : {})}
      />
      {props.switchIconPosition && props.icon ? (
        <span className="input_icon" data-testid={`${props.name}_iconPosition--right`}>
          {props.icon}
        </span>
      ) : null}
    </div>
  );
}

export default Input;

function getClassNames(
  className?: string,
  variant?: Variant,
  size?: Size,
  hasError?: boolean | string,
  switchIconPosition?: boolean
) {
  return classNames(className, {
    inputBox: true,
    [`inputBox--${variant}`]: variant,
    [`inputBox--${size}`]: size,
    [`inputBox--hasError`]: hasError,
    "iconPosition--right": switchIconPosition
  });
}
